/**
 * View modes for the calendar component.
 */
export const VIEW_MODE = {
  CALENDAR: "calendar",
  MONTHLY: "monthly",
  YEARLY: "yearly",
};

/**
 * Option values that can be used with Intl to represent a part or multiple parts of a date.
 */
export const REPRESENTATION_VALUES = {
  LONG: "long",
  SHORT: "short",
  NARROW: "narrow",
  NUMERIC: "numeric",
  TWO_DIGIT: "2-digit",
};

/**
 * Navigation options for the calendar component.
 */
export const NAV_OPTIONS = {
  PREVIOUS_MONTH: "previous_month",
  PREVIOUS_YEAR: "previous_year",
  NEXT_MONTH: "next_month",
  NEXT_YEAR: "next_year",
  MONTH: "month",
  MONTH_YEAR: "month_year",
};
